import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UserAddPlusSvg = function UserAddPlusSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.485 3.596a4.598 4.598 0 1 1 6.502 6.502 4.598 4.598 0 0 1-6.502-6.502m3.25.032a3.218 3.218 0 1 0 0 6.437 3.218 3.218 0 0 0 0-6.437",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.38 15.948v1.474h8.505V18.8H2v-3.67l.354-.197a16.7 16.7 0 0 1 8.152-2.11c1.665 0 3.275.242 4.794.695l-.394 1.322a15.4 15.4 0 0 0-4.4-.638h-.001a15.3 15.3 0 0 0-7.126 1.745M17.172 13.973v3.448h-3.448v1.38h3.448v3.448h1.38v-3.448H22v-1.38h-3.448v-3.448z"
  }));
};
export var UserAddPlus = function UserAddPlus(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UserAddPlusSvg
  }));
};